import { useState } from 'react'

const useFormInputs = callback => {
    const [inputs, setInputs] = useState({})

    const handleSubmit = event => {
        if (event) {
            event.preventDefault()
        }
        callback()
    }

    const handleInputChange = (event, subKey) => {
        event.persist()
        if (!subKey) {
            setInputs(inputs => ({
                ...inputs,
                [event.target.name]: event.target.value || ''
            }))
        } else {
            setInputs(inputs => ({
                ...inputs,
                [subKey]: {
                    ...inputs[subKey],
                    [event.target.name]: event.target.value || ''
                }
            }))
        }
    }

    const handleFilterChange = (value, type) => {
        setInputs(inputs => ({
            ...inputs,
            [type]: value || ''
        }))
    };

    const handleSwitchChange = event => {
        setInputs(inputs => ({
            ...inputs,
            [event.target.name]: event.target.checked
        }))
    };

    const clearInput = (name) => {
        setInputs(inputs => ({
            ...inputs,
            [name]: ''
        }))
    };

    const clearAllInputs = () => {
        setInputs({});
    };

    return {
        clearInput,
        clearAllInputs,
        handleSubmit,
        handleInputChange,
        handleSwitchChange,
        handleFilterChange,
        inputs,
        setInputs
    }
}

export default useFormInputs
